<sm-title-bar pageTitle="{{ 'pay_credits.title' | translate }}" [backWithParams]="true">
  <ng-template #addButton>
    <div class="d-flex search-field" (click)="payCredit()">
      <button mat-flat-button color="accent" style="border: 1px solid #FFC107 !important;
          color: #ffffff !important;
          border-radius: 6px;
          background-color: #FFC107;
          width: 180px;">
        <mat-icon class="material-icons-round" [inline]="true">add</mat-icon>
        {{ 'pay_credits.btn_txt' | translate }}
      </button>

    </div>
  </ng-template>
</sm-title-bar>


<div class="" *ngIf="!loader && expenseData.length > 0">
   <div class="row">
      <div class="col-sm-4" *ngFor="let data of expenseData">
    <div class="plan-card" style="position: relative;" >
      <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options"
        style="position: absolute; right: 15px; top: 2px;">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu2="matMenu">
        <button mat-menu-item (click)="viewDetails(data)">
          <mat-icon class="material-icons-outlined">info</mat-icon>
          <span>{{ 'pay_credits.op1_view_details' | translate }}</span>
        </button>
      </mat-menu>
      <h2 class="plan-title">{{ data.amount}}</h2>
      <p class="plan-info">
        <span class="label">Status: </span> <span class="value">{{ data.status1 }} </span>,
        <span class="label">Type: </span> <span class="value">{{ data.payment_mode1 }} </span>, 
      </p>
      <p class="plan-cost">
        <span class="label">Reason: </span> <span class="value">{{ data.purpose }} </span>
        <span class="label">Repayment date: </span> <span class="value">{{ data.aproxRepaymentDate | date }} </span>
      </p>
      <p class="plan-cost">
        <span class="label">{{data.creationDate | date}}</span>
      </p>
    </div>
    </div>
    </div>
  </div>


<div class="row" *ngIf="!loader && expenseData.length == 0">
  <div class="col-sm-12" >
    <div style="padding: 20px 18px 20px 18px;border-radius: var(--dra-radius-x-small);transition: 0.3s;">
      <div class="top_section_order">
        <div class="row">
         <div class="nal_rrty">
          <div style="text-align:center;min-height: 500px;padding-top: 210px">
          <div class="cv_notifia">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512.002 512.002" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M502.903 96.829c-6.634-7.842-15.924-12.632-26.161-13.487L116.185 53.236c-10.238-.855-20.192 2.328-28.035 8.961-7.811 6.607-12.594 15.85-13.476 26.037L67.42 156.29H38.455C17.251 156.29 0 173.541 0 194.745v225.702c0 21.204 17.251 38.455 38.455 38.455h361.813c21.205 0 38.456-17.251 38.456-38.455v-36.613l12.839 1.072c1.083.09 2.16.135 3.228.135 19.768 0 36.62-15.209 38.294-35.257l18.781-224.919c.854-10.237-2.329-20.193-8.963-28.036zM38.455 176.29h361.813c10.176 0 18.456 8.279 18.456 18.455v20.566H20v-20.566c0-10.176 8.279-18.455 18.455-18.455zM20 235.311h398.724V276.8H20zm380.268 203.591H38.455c-10.176 0-18.455-8.279-18.455-18.455V296.8h398.724v123.647c0 10.176-8.28 18.455-18.456 18.455zM491.935 123.2l-18.781 224.919c-.847 10.141-9.788 17.706-19.927 16.856l-14.503-1.211V194.745c0-21.204-17.251-38.455-38.456-38.455H87.534l7.039-66.04c.008-.076.015-.151.021-.228.847-10.141 9.783-17.705 19.927-16.855l360.558 30.106c4.913.41 9.372 2.709 12.555 6.473s4.711 8.541 4.301 13.454z" fill="#6d6d6d" opacity="1" data-original="#000000" class=""></path><path d="M376.873 326.532h-96.242c-5.523 0-10 4.477-10 10v62.789c0 5.523 4.477 10 10 10h96.242c5.523 0 10-4.477 10-10v-62.789c0-5.523-4.477-10-10-10zm-10 62.789h-76.242v-42.789h76.242z" fill="#6d6d6d" opacity="1" data-original="#000000" class=""></path></g></svg>
          </div>
          <div>
            <p style="margin-top: 18px; color: #a8a8a8; font-size: 17px;  line-height: 24px;">
              No information of any credits yet. Check with your employer whether they started adding those records in the system. 
           </p>
         </div>
          </div>
        </div>
       </div>
      </div>
    </div>
  </div>
</div>

<!-- 
<mat-card appearance="outlined">
  <mat-card-header class="justify-content-between align-items-center mb-3">

  </mat-card-header>
  <div class="rounded-3 bg-light" *ngIf="!loader">
    <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="expenseData" [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate">
    </sm-data-table>
  </div>
</mat-card>



<ng-template #menuTemplate let-rowvalue>

  <button mat-menu-item (click)="viewDetails(rowvalue)">
    <mat-icon class="material-icons-outlined">info</mat-icon>
    <span>{{ 'pay_credits.op1_view_details' | translate }}</span>
  </button>
</ng-template> -->